var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 295,
    height: 140,
    viewBox: "0 0 295 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -1051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 140,
    transform: "translate(40 1051)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.498 1056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.418,117.708l-.367-.083A83.559,83.559,0,0,1,184,117.4l-.367.083a82.7,82.7,0,0,0-81.085-64.62C63.988,52.868,29.866,80.137,21.418,117.708Z",
    transform: "translate(4.973 12.292)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.782,22.725a10.22,10.22,0,1,0-10.235-10.22A10.227,10.227,0,0,0,65.782,22.725Z",
    transform: "translate(13.234 0.553)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.305,103.591a3.791,3.791,0,0,0,1.413,1.908,3.257,3.257,0,0,0-1.156-4.266A3.781,3.781,0,0,0,28.305,103.591Z",
    transform: "translate(6.706 24.088)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.087,103.107a3.782,3.782,0,0,1,.983,2.16,3.263,3.263,0,0,1-3.172-3.083A3.79,3.79,0,0,1,29.087,103.107Z",
    transform: "translate(6.389 24.318)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.876,103.591a3.791,3.791,0,0,0,1.413,1.908,3.257,3.257,0,0,0-1.156-4.266A3.781,3.781,0,0,0,47.876,103.591Z",
    transform: "translate(11.373 24.088)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.662,103.107a3.782,3.782,0,0,1,.983,2.16,3.263,3.263,0,0,1-3.172-3.083A3.79,3.79,0,0,1,48.662,103.107Z",
    transform: "translate(11.059 24.318)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.489,31.913l-3.849-3.075L70.193,9.624h54.649V26.533L89.435,50.358Z",
    transform: "translate(11.543 2.329)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.847,20.365V10.007h-7.256v2.537l-2.708-2.919L99.18,28.771l-6.927,4.6L81.512,111.453l16.2,16.118h37.646V29.537Z",
    transform: "translate(19.45 2.329)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.135,25.094h-58.5V124.24h58.5Z",
    transform: "translate(11.554 5.661)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7,85.428H66.922v24.21H77.7Z",
    transform: "translate(15.974 20.263)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.524,91.746V87.9H53.906v3.843h4.618Z",
    transform: "translate(12.846 20.862)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.14,93.472H53.906v3.843h4.618V93.472Z",
    transform: "translate(12.846 22.21)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.722,87.9H60.1v3.843h4.618Z",
    transform: "translate(14.337 20.862)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.722,93.472H60.1v3.843h4.618Z",
    transform: "translate(14.337 22.21)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.933,91.746V87.9H79.314v3.843h4.618Z",
    transform: "translate(18.958 20.862)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.548,93.472H79.314v3.843h4.618V93.472Z",
    transform: "translate(18.958 22.21)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.132,87.9H85.514v3.843h4.618Z",
    transform: "translate(20.449 20.862)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.132,93.472H85.514v3.843h4.618Z",
    transform: "translate(20.449 22.21)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.962,29.865V26.023h-4.618v3.843h4.618Z",
    transform: "translate(25.219 6.193)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.577,31.592h-4.233v3.843h4.618V31.592Z",
    transform: "translate(25.219 7.518)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.159,26.022h-4.618v3.843h4.618Z",
    transform: "translate(26.71 6.193)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.159,31.592h-4.618v3.843h4.618Z",
    transform: "translate(26.71 7.518)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.962,47.192V43.349h-4.618v3.843h4.618Z",
    transform: "translate(25.219 10.316)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.577,48.918h-4.233v3.843h4.618V48.918Z",
    transform: "translate(25.219 11.641)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.159,43.349h-4.618v3.843h4.618Z",
    transform: "translate(26.71 10.316)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.159,48.918h-4.618v3.843h4.618Z",
    transform: "translate(26.71 11.641)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.962,64.518V60.675h-4.618v3.843h4.618Z",
    transform: "translate(25.219 14.439)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.577,66.245h-4.233v3.843h4.618V66.245Z",
    transform: "translate(25.219 15.765)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.159,60.675h-4.618v3.843h4.618Z",
    transform: "translate(26.71 14.439)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.159,66.245h-4.618v3.843h4.618Z",
    transform: "translate(26.71 15.765)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.962,81.845V78h-4.618v3.843h4.618Z",
    transform: "translate(25.219 18.563)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.577,83.571h-4.233v3.843h4.618V83.571Z",
    transform: "translate(25.219 19.888)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.159,78h-4.618v3.843h4.618Z",
    transform: "translate(26.71 18.563)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.159,83.571h-4.618v3.843h4.618Z",
    transform: "translate(26.71 19.888)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.55,29.116H53.906v9.223H98.55Z",
    transform: "translate(12.828 6.924)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.55,43.968H53.906v9.223H98.55Z",
    transform: "translate(12.828 10.455)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.55,58.819H53.906v9.223H98.55Z",
    transform: "translate(12.828 13.987)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.55,73.671H53.906v9.223H98.55Z",
    transform: "translate(12.828 17.519)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.5,104.609H.5v.376h214Z",
    transform: "translate(0 24.905)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5,69.627H29.389v43.662H30.5Z",
    transform: "translate(6.991 16.439)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.723,79.485c.071,15.268-10.687,27.694-10.687,27.694S21.165,94.852,21.094,79.584,31.781,51.89,31.781,51.89,42.653,64.217,42.723,79.485Z",
    transform: "translate(4.984 12.146)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.723,79.485c.071,15.268-10.687,27.694-10.687,27.694S21.165,94.852,21.094,79.584,31.781,51.89,31.781,51.89,42.653,64.217,42.723,79.485Z",
    transform: "translate(4.984 12.146)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.912,69.627H17.8v43.662h1.107Z",
    transform: "translate(4.188 16.439)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.133,79.485c.07,15.268-10.687,27.694-10.687,27.694S9.575,94.852,9.5,79.584,20.191,51.89,20.191,51.89,31.063,64.217,31.133,79.485Z",
    transform: "translate(2.179 12.146)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.038,26.56c-8.72.04-15.817.169-15.817.169s8.437-11.159,15.786-7.025A100.418,100.418,0,0,0,162.8,26.583S155.759,26.519,147.038,26.56Z",
    transform: "translate(31.388 4.468)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.068,43.829C21.348,43.87,14.25,44,14.25,44s8.437-11.159,15.786-7.025a100.436,100.436,0,0,0,15.792,6.879S38.788,43.789,30.068,43.829Z",
    transform: "translate(3.327 8.575)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.556,7.775c-8.72.04-15.818.169-15.818.169S48.175-3.216,55.525.919A100.438,100.438,0,0,0,71.317,7.8S64.276,7.735,55.556,7.775Z",
    transform: "translate(9.43 0)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.64,69.627h-1.107v43.662h1.107Z",
    transform: "translate(37.756 16.439)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.864,79.485c.071,15.268-10.686,27.694-10.686,27.694S149.3,94.852,149.235,79.584,159.921,51.89,159.921,51.89,170.793,64.217,170.864,79.485Z",
    transform: "translate(35.748 12.146)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.742,83.485h11.172V80.793h6.163v2.693h11.557V95.41H144.077v15h-6.163v-15H126.742l-5.779-6.54Z",
    transform: "translate(28.905 19.141)",
    fill: "#3f3d56"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.eef9515094332134742a3a1d5806b47a.svg";
export { ForwardRef as ReactComponent };